angular.module('flowingly.runner.print').config(config);

config.$inject = ['$stateProvider'];

function config($stateProvider) {
  $stateProvider.state('app.print.flowmodelschema', {
    url: '/flowmodelschema',
    templateUrl: 'Client/runner.print/runner.print.flowmodelschema.tmpl.html',
    controller: 'runnerPrintFlowModelSchemaController',
    controllerAs: '$ctrl'
  });
}
